import React from 'react';
import {Link} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import EncodeSansLight from '../../../assets/fonts/Encode_Sans/EncodeSans-Light.ttf';
import prevencion_icon from "../../../assets/images/prevencion_icon.svg";
import ButtonCotizarMobile from "./Mobile/ButtonCotizarMobile";

const useStyles = makeStyles(theme => ({
    btnCotizar: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "20px",
        background: "#BB0D66",
        padding: "10px 30px 10px 30px",
        marginLeft: "auto",
        marginRight: "auto",
        textDecoration: "none",
        border: "solid #BB0D66 0px",
        fontFamily: EncodeSansLight,
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    bannerBox: {
        backgroundColor: "#ffffff",
        borderRadius: "20px",
        width: "450px",
        height: "200px",
        boxShadow: "5px 10px 18px #888888",
    },
}))

function ProductBannerPrevencion(props) {
    const classes = useStyles();
    const {isMobile} = props;
    return (
        <React.Fragment>
            <div
                className={isMobile ? "box-mobile" : classes.bannerBox}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: isMobile ? "0px" : "24px"
                }}
            >
                <img
                    style={{
                        width: "auto",
                        maxWidth: isMobile ? "250px" : "400px",
                        height: isMobile ? "24px" : "32px",
                        marginBottom: isMobile ? "8px" : "24px",
                    }}
                    src={prevencion_icon}
                />

                <Link
                    to={{pathname: `cotizar/prevencion`}}
                    style={{textDecoration: "none", color: "#000"}}
                >
                    {isMobile
                        ?
                        <ButtonCotizarMobile/>
                        :
                        <button
                            className={classes.btnCotizar}
                            type="button"
                        >
                            Cotizar
                        </button>
                    }

                </Link>

            </div>
        </React.Fragment>
    );
}

export default ProductBannerPrevencion;